import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Transition as _Transition, Teleport as _Teleport, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "px-6 py-4 border-b border-slate-200 shrink-0"
};
const _hoisted_2 = {
  class: "flex items-center justify-between"
};
const _hoisted_3 = {
  class: "flex items-center gap-3"
};
const _hoisted_4 = ["src", "alt"];
const _hoisted_5 = {
  key: 1,
  class: "w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center"
};
const _hoisted_6 = {
  class: "text-xs text-slate-400"
};
const _hoisted_7 = {
  class: "px-6 py-4 border-b border-slate-100 bg-slate-50/50 shrink-0"
};
const _hoisted_8 = {
  class: "flex items-center gap-3"
};
const _hoisted_9 = ["disabled"];
const _hoisted_10 = {
  class: "flex-1 overflow-y-auto"
};
const _hoisted_11 = {
  key: 0,
  class: "p-6 space-y-3"
};
const _hoisted_12 = {
  key: 1,
  class: "py-12"
};
const _hoisted_13 = {
  key: 2,
  class: "divide-y divide-slate-100"
};
const _hoisted_14 = {
  class: "flex items-center gap-3 min-w-0"
};
const _hoisted_15 = {
  class: "min-w-0"
};
const _hoisted_16 = {
  class: "flex items-center gap-2"
};
const _hoisted_17 = {
  class: "text-sm font-medium text-slate-900 truncate"
};
const _hoisted_18 = {
  class: "text-xs text-slate-400 truncate"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = {
  class: "px-6 py-3 border-t border-slate-200 bg-slate-50/50 shrink-0"
};
const _hoisted_21 = {
  class: "text-xs text-slate-400"
};
const _hoisted_22 = {
  class: "font-medium text-slate-600"
};
import { ref, watch } from 'vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { getKfServicers, addKfServicer, removeKfServicer } from '@/api/weworkKf';
import { getUserList } from '@/api/user';
import AppModal from '@/components/AppModal.vue';
import UserSelector from '@/components/UserSelector/index.vue';
export default {
  __name: 'KfServicerModal',
  props: {
    show: Boolean,
    account: Object
  },
  emits: ['update:show'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emit = __emit;

    // 接待人员列表
    const loading = ref(false);
    const servicerList = ref([]);

    // 用户列表（供名称回显）
    const userOptions = ref([]);

    // 添加接待人员
    const selectedUserId = ref(null);
    const adding = ref(false);

    // 状态配置
    const statusConfig = {
      1: {
        label: '启用',
        dot: 'bg-emerald-400',
        text: 'text-emerald-700',
        bg: 'bg-emerald-50'
      },
      0: {
        label: '禁用',
        dot: 'bg-slate-400',
        text: 'text-slate-600',
        bg: 'bg-slate-100'
      }
    };

    // 监听弹窗打开
    watch(() => props.show, val => {
      if (val && props.account?.openKfid) {
        fetchServicers();
        loadUsers();
        selectedUserId.value = null;
      }
    });

    // 加载用户列表
    async function loadUsers() {
      if (userOptions.value.length > 0) return;
      try {
        const response = await getUserList({});
        const list = response?.list || response?.records || response?.data || response || [];
        userOptions.value = (Array.isArray(list) ? list : []).map(u => ({
          id: u.id,
          name: u.displayName || u.name || u.username,
          avatar: u.avatar
        }));
      } catch {
        // ignore
      }
    }

    // 获取接待人员列表
    async function fetchServicers() {
      loading.value = true;
      try {
        const data = await getKfServicers(props.account.openKfid);
        servicerList.value = data || [];
      } catch (error) {
        ElMessage.error('加载接待人员列表失败');
      } finally {
        loading.value = false;
      }
    }

    // 根据userId查找用户名
    const getUserName = userId => {
      const user = userOptions.value.find(u => u.id === userId);
      return user?.name || null;
    };

    // 添加接待人员
    const handleAdd = async () => {
      if (!selectedUserId.value) {
        return ElMessage.warning('请选择接待人员');
      }
      adding.value = true;
      try {
        await addKfServicer(props.account.openKfid, selectedUserId.value);
        ElMessage.success('添加成功');
        selectedUserId.value = null;
        fetchServicers();
      } catch (error) {
        ElMessage.error(error.message || '添加失败');
      } finally {
        adding.value = false;
      }
    };

    // 移除接待人员
    const handleRemove = async servicer => {
      try {
        await ElMessageBox.confirm('确定要移除该接待人员吗？', '确认移除', {
          confirmButtonText: '确认移除',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await removeKfServicer(servicer.id);
        ElMessage.success('移除成功');
        fetchServicers();
      } catch (error) {
        if (error !== 'cancel') {
          ElMessage.error('移除失败');
        }
      }
    };

    // 格式化时间
    const formatTime = time => {
      if (!time) return '-';
      return new Date(time).toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    };

    // 关闭
    const handleClose = () => {
      emit('update:show', false);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(_Teleport, {
        to: "body"
      }, [_createVNode(_Transition, {
        name: "modal"
      }, {
        default: _withCtx(() => [_createVNode(AppModal, {
          visible: __props.show,
          size: "lg",
          onClose: handleClose
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.account?.avatar ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: __props.account.avatar,
            alt: __props.account?.name,
            class: "w-8 h-8 rounded-full object-cover border border-slate-200"
          }, null, 8, _hoisted_4)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[1] || (_cache[1] = [_createElementVNode("svg", {
            class: "w-4 h-4 text-primary-600",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
          })], -1)]))])), _createElementVNode("div", null, [_cache[2] || (_cache[2] = _createElementVNode("h3", {
            class: "text-lg font-semibold text-slate-900"
          }, "接待人员管理", -1)), _createElementVNode("p", _hoisted_6, _toDisplayString(__props.account?.name), 1)])]), _createElementVNode("button", {
            onClick: handleClose,
            class: "p-2 text-slate-400 hover:text-slate-600 rounded-lg hover:bg-slate-100 transition-colors cursor-pointer"
          }, [...(_cache[3] || (_cache[3] = [_createElementVNode("svg", {
            class: "w-5 h-5",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M6 18L18 6M6 6l12 12"
          })], -1)]))])])]), _createElementVNode("div", _hoisted_7, [_cache[4] || (_cache[4] = _createElementVNode("label", {
            class: "block text-sm font-medium text-slate-700 mb-2"
          }, "添加接待人员", -1)), _createElementVNode("div", _hoisted_8, [_createVNode(UserSelector, {
            modelValue: selectedUserId.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => selectedUserId.value = $event),
            placeholder: "搜索并选择用户",
            class: "flex-1"
          }, null, 8, ["modelValue"]), _createElementVNode("button", {
            onClick: handleAdd,
            disabled: !selectedUserId.value || adding.value,
            class: "btn-primary"
          }, _toDisplayString(adding.value ? '添加中...' : '添加'), 9, _hoisted_9)])]), _createElementVNode("div", _hoisted_10, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_11, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, n => {
            return _createElementVNode("div", {
              key: n,
              class: "flex items-center gap-3 animate-pulse"
            }, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", {
              class: "w-10 h-10 bg-slate-200 rounded-full shrink-0"
            }, null, -1), _createElementVNode("div", {
              class: "flex-1"
            }, [_createElementVNode("div", {
              class: "h-4 bg-slate-200 rounded w-24 mb-1"
            }), _createElementVNode("div", {
              class: "h-3 bg-slate-200 rounded w-32"
            })], -1)]))]);
          }), 64))])) : servicerList.value.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
            class: "flex flex-col items-center"
          }, [_createElementVNode("div", {
            class: "w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mb-3"
          }, [_createElementVNode("svg", {
            class: "w-6 h-6 text-slate-400",
            fill: "none",
            stroke: "currentColor",
            viewBox: "0 0 24 24"
          }, [_createElementVNode("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "1.5",
            d: "M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
          })])]), _createElementVNode("p", {
            class: "empty-state-title"
          }, "暂无接待人员"), _createElementVNode("p", {
            class: "empty-state-desc"
          }, "请在上方选择用户添加")], -1)]))])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(servicerList.value, servicer => {
            return _openBlock(), _createElementBlock("div", {
              key: servicer.id,
              class: "px-6 py-3 flex items-center justify-between hover:bg-slate-50 transition-colors"
            }, [_createElementVNode("div", _hoisted_14, [_cache[7] || (_cache[7] = _createElementVNode("div", {
              class: "w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center shrink-0"
            }, [_createElementVNode("svg", {
              class: "w-5 h-5 text-slate-500",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "1.5",
              d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
            })])], -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_createElementVNode("p", _hoisted_17, _toDisplayString(getUserName(servicer.userId) || servicer.weworkUserid || `用户#${servicer.userId}`), 1), _createElementVNode("span", {
              class: _normalizeClass([[statusConfig[servicer.status]?.bg, statusConfig[servicer.status]?.text], "inline-flex items-center gap-1 px-1.5 py-0.5 rounded-full text-xs font-medium shrink-0"])
            }, [_createElementVNode("span", {
              class: _normalizeClass([statusConfig[servicer.status]?.dot, "w-1.5 h-1.5 rounded-full"])
            }, null, 2), _createTextVNode(" " + _toDisplayString(statusConfig[servicer.status]?.label || '未知'), 1)], 2)]), _createElementVNode("p", _hoisted_18, " 添加时间：" + _toDisplayString(formatTime(servicer.createTime)), 1)])]), _createElementVNode("button", {
              onClick: $event => handleRemove(servicer),
              class: "p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors cursor-pointer shrink-0",
              title: "移除"
            }, [...(_cache[8] || (_cache[8] = [_createElementVNode("svg", {
              class: "w-4 h-4",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [_createElementVNode("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
            })], -1)]))], 8, _hoisted_19)]);
          }), 128))]))]), _createElementVNode("div", _hoisted_20, [_createElementVNode("p", _hoisted_21, [_cache[9] || (_cache[9] = _createTextVNode(" 共 ", -1)), _createElementVNode("span", _hoisted_22, _toDisplayString(servicerList.value.length), 1), _cache[10] || (_cache[10] = _createTextVNode(" 名接待人员 ", -1))])])]),
          _: 1
        }, 8, ["visible"])]),
        _: 1
      })]);
    };
  }
};